import { useFormik, Form, FormikProvider } from 'formik';
import { Button } from 'styled';
import InputField from 'components/formik/InputField';
import Model from 'components/Modal';
import { updateDocumentByID } from 'apis/customApiHandler';
import { useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { useState } from 'react';

const EditVehicleType = ({ handleClick, data, desable }) => {
  const [isDesable, setIsDesable] = useState(desable);
  const queryClient = useQueryClient();
  const formik = useFormik({
    initialValues: {
      name: data.name,
    },
    onSubmit: async (values) => {
      const result = await updateDocumentByID('vehicle-type', data._id, values);
      if(result?.status == "success"){
        toast.success('Successfully updated');
      }
      queryClient.invalidateQueries('vehicle-types');
      handleClick();
    },

    validate: (values) => {
      let errors = {};
      if (!values.name) errors.name = 'Required';
      return errors;
    },
  });

  return (
    <Model
      handleClick={handleClick}
      title={`${desable ? 'View' : 'Edit'} Vehicle Type`}
      className="max-w-2xl"
    >
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 font-medium text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
          <InputField
            type="text"
            label="Vehicle Type Name"
            name="name"
            desable={isDesable}
          />
        </Form>
        {isDesable ? (
          <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
            <Button bgSecondary onClick={handleClick}>
              Cancel
            </Button>
            <Button type="button" bgPrimary onClick={() => setIsDesable(false)}>
              Edit
            </Button>
          </div>
        ) : (
          <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
            <Button bgSecondary onClick={handleClick}>
              Cancel
            </Button>
            <Button type="button" bgPrimary onClick={formik.handleSubmit}>
              Save Changes
            </Button>
          </div>
        )}
      </FormikProvider>
    </Model>
  );
};

export default EditVehicleType;
